/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const paymentProcessRequestV4Schema = z
  .object({
    orderReference: z
      .string()
      .nullish()
      .describe("The order reference — the bank's `order_reference` query parameter. Required."),
    paymentReference: z
      .string()
      .nullish()
      .describe(
        "The payment reference — the bank's `payment_reference` query parameter. Required."
      ),
  })
  .describe('The bank return: the two references the bank appends to the return URL.')
